// src/hooks/useClientLogContext.js
import { useMemo } from 'react';
import { useClient } from '../contexts/ClientContext';

/**
 * Cliente e processo a que o consumo de IA é atribuído (chat_log.cod_cli / cod_processo).
 * O processo vem do SedLex (processoSession) e só conta enquanto pertencer ao cliente
 * selecionado: o código do processo é "{cod_cli}.{sequência}".
 */
export function useClientLogContext() {
  const { clienteAtual } = useClient();
  const codCli = clienteAtual.codCliente || null;

  return useMemo(() => {
    const processo = localStorage.getItem('processoSession');
    const codProcesso = codCli && processo && processo.startsWith(`${codCli}.`) ? processo : null;

    return { codCli, codProcesso };
  }, [codCli]);
}
